import { useState } from "react";
import addicon from "../../../../../assets/shapes_svg/ambition/actionplans/add-icon.svg";
import "./index.css";
import { CustomList } from "./CustomList";
import { createDepartment } from "../../../../../apis/Business/DepartmentEffortApi";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import { useUserAccess } from "../../../../../components/WriteAccessContext";

export const CustomDepartment = ({ user, setNewDepartment }) => {
  const [newEffort, setNewEffort] = useState("");
  const [newDept, setNewDept] = useState("");
  const [isEditDept, setIsEditDept] = useState(false);
  const { triggerInvalidate } = useInvalidateQuery();
  const { userAccess } = useUserAccess();

  const handleSaveDept = async () => {
    if (newDept.trim()) {
      try {
        const newDepartmentData = await createDepartment(
          newDept.trim(),
          triggerInvalidate,
          user
        );
        setNewDepartment(newDepartmentData);
        setIsEditDept(false);
      } catch (error) {
        console.error("Failed to create department:", error);
      }
    }
  };

  const handleSaveEffort = () => {};
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        gap: "15px",
        width: "100%",
      }}
    >
      <div
        className="custom-action-plan-container"
        style={{ flexDirection: "column", height: "209px" }}
      >
        {isEditDept && userAccess === "write" ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "5px",
              width: "100%",
            }}
          >
            <input
              type="text"
              value={newDept}
              onChange={(e) => {
                setNewDept(e.target.value);
              }}
              onBlur={() => {
                handleSaveDept(newDept);
                setIsEditDept(!isEditDept);
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSaveDept(newDept);
                  setIsEditDept(!isEditDept);
                }
              }}
              autoFocus
              style={{
                background: "transparent",
                border: "none",
                outline: "none",
                color: "#1a3864",
                maxWidth: "100%",
              }}
            />
          </div>
        ) : (
          <div
            onClick={() => setIsEditDept(!isEditDept)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              gap: "33px",
            }}
          >
            <h5>Add Department/Action Plan</h5>
            <img src={addicon} alt="Add icon" width={50} height={50} />
          </div>
        )}
      </div>
      <div style={{ display: "flex" }}>
        <CustomList
          className={"custom-action-plan-container"}
          newName={newEffort}
          setNewName={setNewEffort}
          handleSave={handleSaveEffort}
        />
      </div>
    </div>
  );
};
